import axios from 'axios'

export default function setup() {
axios.interceptors.request.use(function(config) {
  if (config.method == 'post' || config.method == 'get') {
      const auth_token = sessionStorage.getItem('token');
      const usuario = localStorage.getItem('usuario');
      const documento = localStorage.getItem('documento');
      const servicio = localStorage.getItem('servicio');
      const servicio_2 = localStorage.getItem('servicio2');
      const modulo = localStorage.getItem("modulo");
      const departamento = localStorage.getItem("departamento");
      const municipio = localStorage.getItem("municipio");
      const sede = localStorage.getItem("sede_usuario");
        if(auth_token) {
          config.headers.Authorization = `Bearer ${auth_token}`;
          config.headers.usuario = usuario;
          config.headers.documento = documento;
          config.headers.servicio = servicio;
          config.headers.servicio2 = servicio_2;
          config.headers.modulo = modulo;
          config.headers.departamento = departamento;
          config.headers.municipio = municipio;
          config.headers.sede = sede;
        } 
        // else{
        //   config.headers.usuario = usuario;
        // }
  }
  // else{
  //   config.headers.Authorization = `Bearer ${auth_token}`;
  //   config.headers.usuario = usuario;
  // }
    return config;
  }, function(err) {
    // localStorage.clear();
    // sessionStorage.clear();
    // window.location.replace("http://localhost:8081");
    return Promise.reject(err);
  });
}